/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация о вложении
 */
export interface Attachment {
  /** @format uuid */
  id?: string;
  fileId?: string;

  /** @format uuid */
  documentId?: string;
  ready?: boolean;
  errorCode?: string;
  errorDescription?: string;

  /** @format int64 */
  size?: number;
  fileName?: string;
}

/**
 * Данные для создания заявления
 */
export interface QualifiedInvestorCreate {
  contactPhoneNumber?: string;
  contractNumber?: string;
  contractDate?: string;
  attachments?: Attachment[];
}

/**
 * Данные сохраненного документа
 */
export interface DocumentSaveResponse {
  /** @format uuid */
  id: string;
  number: string;
  state: string;
}

/**
 * Информация о неторговом поручении на сохранение
 */
export interface NonTradingOrderSave {
  contractNumber?: string;

  /** @format date */
  contractDate?: string;
  clientCode?: string;
  entireBalance?: boolean;
  amount?: number;
  currencyCode?: string;
  orderType?: string;

  /** @format uuid */
  debitAccountId?: string;
  debitAccountNumber?: string;
  debitTradingPlatformName?: string;

  /** @format uuid */
  transferAccountId?: string;
  transferAccountNumber?: string;
  transferTradingPlatformName?: string;
}

/**
 * Разрешение на документ
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  description?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Основная информация о Заявлении на получение статуса квалифицированного инвестора
 */
export interface QualifiedInvestorOrderBase {
  /** @format uuid */
  id?: string;
  contractNumber?: string;

  /** @format date */
  contractDate?: string;

  /** @format date-time */
  stateChangeDate?: string;
  state?: string;

  /** @format date-time */
  createDate?: string;

  /** @format date */
  assignmentDate?: string;

  /** @format date */
  endDate?: string;
  documentNumber?: string;
  permissions?: PermissionResponse[];
}

/**
 * Список заявлений
 */
export interface QualifiedInvestorOrderList {
  hasMore?: boolean;
  data?: QualifiedInvestorOrderBase[];
}

/**
 * Полная информация о Заявлении на получение статуса квалифицированного инвестора
 */
export interface QualifiedInvestorOrderDetail {
  /** @format uuid */
  id?: string;

  /** @format date-time */
  createDate?: string;
  clientAbsId?: string;
  contractNumber?: string;

  /** @format date */
  contractDate?: string;

  /** @format date */
  sendDate?: string;
  state?: string;
  stateDesc?: string;
  clientFullName?: string;
  clientShortName?: string;
  clientInn?: string;
  contactPhoneNumber?: string;
  branchCode?: string;
  documentNumber?: string;

  /** @format date */
  assignmentDate?: string;

  /** @format date */
  endDate?: string;

  /** @format date-time */
  stateChangeDate?: string;

  /** @format date */
  bankProcessDate?: string;

  /** @format date */
  bankExecutionDate?: string;
  bankRejectReason?: string;
  attachments?: Attachment[];
  permissions?: PermissionResponse[];
}

/**
 * Разрешения на документ
 */
export interface PermissionsResponse {
  /** Тип документа */
  documentType?: string;

  /** Список разрешений для документа */
  permissions?: PermissionResponse[];
}

/**
 * Основная информация о неторговом поручении
 */
export interface NonTradingOrderBase {
  /** @format uuid */
  id?: string;
  orderNumber?: string;

  /** @format date-time */
  orderDate?: string;
  state?: string;
  debitAccountNumber?: string;
  debitTradingPlatformName?: string;
  transferAccountNumber?: string;
  transferTradingPlatformName?: string;
  amount?: number;
  currencyCode?: string;
  entireBalance?: boolean;
  orderType?: "TRANSFER" | "WITHDRAWAL" | "REFILL";
  permissions?: PermissionResponse[];
}

/**
 * Список неторговых поручений
 */
export interface NonTradingOrderList {
  hasMore?: boolean;
  data?: NonTradingOrderBase[];
}

/**
 * Детальная информация о неторговом поручении
 */
export interface NonTradingOrderDetail {
  /** @format uuid */
  id?: string;
  orderNumber?: string;

  /** @format date-time */
  orderDate?: string;
  state?: string;
  stateDesc?: string;

  /** @format date-time */
  stateChangeDate?: string;

  /** @format date-time */
  requestTime?: string;
  requestId?: string;
  contractNumber?: string;

  /** @format date */
  contractDate?: string;
  clientCode?: string;
  transferTradingPlatformName?: string;
  debitTradingPlatformName?: string;
  entireBalance?: boolean;
  amount?: number;
  currencyCode?: string;
  orderType?: "TRANSFER" | "WITHDRAWAL" | "REFILL";

  /** @format uuid */
  debitAccountId?: string;
  debitAccountNumber?: string;

  /** @format uuid */
  transferAccountId?: string;
  transferAccountNumber?: string;
  permissions?: PermissionResponse[];
}

/**
 * Детальная информация о суммах
 */
export interface Amount {
  sum?: number;
  currency?: string;
}

/**
 * Детальная информация о Брокерском счете
 */
export interface BrokerAccount {
  saldo?: string;
  currencyCode?: string;
  accountNumber?: string;
}

/**
 * Детальная информация о брокерском договоре
 */
export interface BrokerContract {
  brokerContractNumber?: string;

  /** @format date */
  brokerContractDate?: string;
  brokerContractStatus?: string;
  isBrokerRightUseSecurities?: boolean;
  isSelectImperfectTransactions?: boolean;
  tariffList?: Tariff[];
  futuresList?: Future[];
  tradingPlatformList?: TradingPlatform[];
}

/**
 * Детальная информация о брокерском обслуживании
 */
export interface BrokerageInfoResponse {
  /** Детальная информация о брокерском договоре */
  brokerContract?: BrokerContract;
  depoContractList?: DepoContract[];
  amounts?: Amount[];
}

/**
 * Детальная информация о депозитарном счете
 */
export interface DepoAccount {
  /** Детальная информация о Ценных бумагах */
  securities?: Security;
  depoAccountNumber?: string;
}

/**
 * Детальная информация о депозитарном договоре
 */
export interface DepoContract {
  depoContractNumber?: string;

  /** @format date */
  depoContractDate?: string;
}

/**
 * Детальная информация об Инструменте срочного рынка
 */
export interface Future {
  outCostRest?: number;
  futuresNumber?: string;
  futuresName?: string;
  futuresQuantity?: string;
  futuresType?: string;
}

/**
 * Детальная информация о Ценных бумагах
 */
export interface Security {
  securitiesName?: string;
  securitiesIsin?: string;
  securitiesAmount?: string;
  securitiesCost?: string;
  securitiesCurrencyCode?: string;
}

/**
 * Детальная информация о тарифе
 */
export interface Tariff {
  tariffPlan?: string;
}

/**
 * Детальная информация о трейдинговой платформе
 */
export interface TradingPlatform {
  clientCode?: string;
  tradingPlatformName?: string;
  depoAccountList?: DepoAccount[];
  brokerAccountList?: BrokerAccount[];
}

/**
 * Базовая информация о брокерском обслуживании
 */
export interface BrokerageBaseInfoResponse {
  clientCode?: string;
  clientName?: string;
  contractNumber?: string;

  /** @format date */
  contractDate?: string;

  /** @format date */
  statusAssignmentDate?: string;

  /** @format date */
  statusEndDate?: string;
}

/**
 * Поля ККБ
 */
export type CcbFields = object;

/**
 * Документ
 */
export interface DocumentOrderCcbResponse {
  /** Тип документа */
  type?: DocumentTypeOrderCcbResponse;

  /** Поля ККБ */
  fields?: CcbFields;
}

/**
 * Тип документа
 */
export interface DocumentTypeOrderCcbResponse {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Документ ККБ */
  orderCcb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: DocumentOrderCcbResponse;
}

export interface ErrorMessage {
  /** @format uuid */
  id?: string;
  message?: string;
}

/**
 * Тип подтверждения
 */
export interface ConfirmTypeResponse {
  /** Тип подтверждения */
  confirmType?: string;
}

/**
 * Счет
 */
export interface Account {
  /** @format uuid */
  id?: string;
  name?: string;
  currency?: string;
  balance?: number;
  type?: string;
  accountNumber?: string;
}

/**
 * Общая информация о Брокерском счете
 */
export interface BrokerAccountBase {
  saldo?: string;
  currencyCode?: string;
  tradingPlatformName?: string;
  accountNumber?: string;
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис Брокерское обслуживание
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-brokerage.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Брокерское обслуживание (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=340936173)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Брокерское обслуживание. Заявления о получении статуса квалифицированного инвестора
     * @name GetQualifiedInvestorOrder
     * @summary Получение детальной информации
     * @request GET:/api/brokerage/external/v1/qual/{id}
     * @secure
     */
    getQualifiedInvestorOrder: (id: string, params: RequestParams = {}) =>
      this.request<QualifiedInvestorOrderDetail, GenericError>({
        path: `/api/brokerage/external/v1/qual/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Брокерское обслуживание. Заявления о получении статуса квалифицированного инвестора
     * @name UpdateQualifiedInvestorStatement
     * @summary Редактирование заявления о получении статуса квалифицированного инвестора
     * @request PUT:/api/brokerage/external/v1/qual/{id}
     * @secure
     */
    updateQualifiedInvestorStatement: (
      id: string,
      data: QualifiedInvestorCreate,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/brokerage/external/v1/qual/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Брокерское обслуживание. Заявления о получении статуса квалифицированного инвестора
     * @name DeleteQualifiedInvestorStatement
     * @summary Удаление заявления о получении статуса квалифицированного инвестора
     * @request DELETE:/api/brokerage/external/v1/qual/{id}
     * @secure
     */
    deleteQualifiedInvestorStatement: (
      id: string,
      params: RequestParams = {}
    ) =>
      this.request<void, void | GenericError>({
        path: `/api/brokerage/external/v1/qual/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name GetNonTradingOrder
     * @summary Получение детальной информации
     * @request GET:/api/brokerage/external/v1/non-trading-order/{id}
     * @secure
     */
    getNonTradingOrder: (id: string, params: RequestParams = {}) =>
      this.request<NonTradingOrderDetail, GenericError>({
        path: `/api/brokerage/external/v1/non-trading-order/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name UpdateNonTradingOrder
     * @summary Редактирование
     * @request PUT:/api/brokerage/external/v1/non-trading-order/{id}
     * @secure
     */
    updateNonTradingOrder: (
      id: string,
      data: NonTradingOrderSave,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError | void>({
        path: `/api/brokerage/external/v1/non-trading-order/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name CreateNonTradingOrderWithId
     * @summary Создание c идентификатором
     * @request POST:/api/brokerage/external/v1/non-trading-order/{id}
     * @secure
     */
    createNonTradingOrderWithId: (
      id: string,
      data: NonTradingOrderSave,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/brokerage/external/v1/non-trading-order/${id}`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name DeleteNonTradingOrder
     * @summary Удаление
     * @request DELETE:/api/brokerage/external/v1/non-trading-order/{id}
     * @secure
     */
    deleteNonTradingOrder: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError | void>({
        path: `/api/brokerage/external/v1/non-trading-order/${id}`,
        method: "DELETE",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Брокерское обслуживание. Заявления о получении статуса квалифицированного инвестора
     * @name GetQualifiedInvestorOrderList
     * @summary Получение списка
     * @request GET:/api/brokerage/external/v1/qual
     * @secure
     */
    getQualifiedInvestorOrderList: (
      query: { position: number; size: number },
      params: RequestParams = {}
    ) =>
      this.request<QualifiedInvestorOrderList, GenericError>({
        path: `/api/brokerage/external/v1/qual`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Брокерское обслуживание. Заявления о получении статуса квалифицированного инвестора
     * @name CreateQualifiedInvestorStatement
     * @summary Создание заявления о получении статуса квалифицированного инвестора
     * @request POST:/api/brokerage/external/v1/qual
     * @secure
     */
    createQualifiedInvestorStatement: (
      data: QualifiedInvestorCreate,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/brokerage/external/v1/qual`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name GetNonTradingOrderList
     * @summary Получение списка
     * @request GET:/api/brokerage/external/v1/non-trading-order
     * @secure
     */
    getNonTradingOrderList: (
      query: { position: number; size: number },
      params: RequestParams = {}
    ) =>
      this.request<NonTradingOrderList, GenericError>({
        path: `/api/brokerage/external/v1/non-trading-order`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name CreateNonTradingOrder
     * @summary Создание
     * @request POST:/api/brokerage/external/v1/non-trading-order
     * @secure
     */
    createNonTradingOrder: (
      data: NonTradingOrderSave,
      params: RequestParams = {}
    ) =>
      this.request<DocumentSaveResponse, GenericError>({
        path: `/api/brokerage/external/v1/non-trading-order`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация по брокерскому обслуживанию клиента
     * @name GetBrokerageInfo
     * @summary Получение информации по брокерскому обслуживанию
     * @request GET:/api/brokerage/external/v1/info
     * @secure
     */
    getBrokerageInfo: (params: RequestParams = {}) =>
      this.request<BrokerageInfoResponse, GenericError | void>({
        path: `/api/brokerage/external/v1/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация по брокерскому обслуживанию клиента
     * @name RequestBrokerageInfo
     * @summary Запрос информации по брокерскому обслуживанию
     * @request POST:/api/brokerage/external/v1/info
     * @secure
     */
    requestBrokerageInfo: (params: RequestParams = {}) =>
      this.request<void, GenericError>({
        path: `/api/brokerage/external/v1/info`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Вложения
     * @name Download
     * @summary Получение файла вложения
     * @request GET:/api/brokerage/external/v1/attachment
     * @secure
     */
    download: (query: { attachmentId: string }, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/brokerage/external/v1/attachment`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Вложения
     * @name UploadFileAttachment
     * @summary Загрузка файла вложения
     * @request POST:/api/brokerage/external/v1/attachment
     * @secure
     */
    uploadFileAttachment: (
      query: { documentType: "NON_TRADING_ORDER" | "QUALIFIED_INVESTOR_ORDER" },
      data: { file: File },
      params: RequestParams = {}
    ) =>
      this.request<Attachment, GenericError>({
        path: `/api/brokerage/external/v1/attachment`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Брокерское обслуживание. Заявления о получении статуса квалифицированного инвестора
     * @name PrintQualifiedInvestorOrder
     * @summary Печать
     * @request GET:/api/brokerage/external/v1/qual/print/{id}
     * @secure
     */
    printQualifiedInvestorOrder: (
      id: string,
      query: { id: string },
      params: RequestParams = {}
    ) =>
      this.request<File, GenericError>({
        path: `/api/brokerage/external/v1/qual/print/${id}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений на документ по его типу
     * @name GetPermissionByDocumentType
     * @summary Получение разрешений на документ
     * @request GET:/api/brokerage/external/v1/permissions
     * @secure
     */
    getPermissionByDocumentType: (
      query: { documentType: "NON_TRADING_ORDER" | "QUALIFIED_INVESTOR_ORDER" },
      params: RequestParams = {}
    ) =>
      this.request<PermissionsResponse, GenericError>({
        path: `/api/brokerage/external/v1/permissions`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Неторговые поручения
     * @name Print
     * @summary Печать
     * @request GET:/api/brokerage/external/v1/non-trading-order/print/{id}
     * @secure
     */
    print: (id: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/brokerage/external/v1/non-trading-order/print/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация по брокерскому обслуживанию клиента
     * @name GetBrokerageBaseInfo
     * @summary Получение базовой информации по брокерскому обслуживанию
     * @request GET:/api/brokerage/external/v1/info/base
     * @secure
     */
    getBrokerageBaseInfo: (params: RequestParams = {}) =>
      this.request<BrokerageBaseInfoResponse, GenericError | void>({
        path: `/api/brokerage/external/v1/info/base`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание
     * @name GetOrderCcb
     * @summary Получение ККБ документа
     * @request GET:/api/brokerage/external/v1/confirmation/order-ccb
     * @secure
     */
    getOrderCcb: (
      query: {
        documentId: string;
        documentType: "NON_TRADING_ORDER" | "QUALIFIED_INVESTOR_ORDER";
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, GenericError | ErrorMessage>({
        path: `/api/brokerage/external/v1/confirmation/order-ccb`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание
     * @name GetClientConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/brokerage/external/v1/confirmation/confirm-type
     * @secure
     */
    getClientConfirmType: (params: RequestParams = {}) =>
      this.request<ConfirmTypeResponse, GenericError | ErrorMessage>({
        path: `/api/brokerage/external/v1/confirmation/confirm-type`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета клиента
     * @name GetAccounts
     * @summary Получение списка cчетов
     * @request GET:/api/brokerage/external/v1/accounts
     * @secure
     */
    getAccounts: (params: RequestParams = {}) =>
      this.request<Account[], GenericError>({
        path: `/api/brokerage/external/v1/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Счета клиента
     * @name GetBrokerAccounts
     * @summary Получение списка брокерских счетов
     * @request GET:/api/brokerage/external/v1/accounts/broker
     * @secure
     */
    getBrokerAccounts: (params: RequestParams = {}) =>
      this.request<BrokerAccountBase[], GenericError>({
        path: `/api/brokerage/external/v1/accounts/broker`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
